export let bidiotvMoviesIq = [{
        id: 1,
        contents: 15,
        name: {
            en: "Motivation",
            be: "Motivation",
            id: "Motivation",
            it: "Motivation",
            se: "Motivation",
            ar: "التحفيز",
            no: "Motivation",
        },
        videos: [{
                category: "Motivation",
                id: 945,
                name: "Environmental Heroes Clean Up the Nile Campaign",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/Environmental+Heroes+Clean+Up+the+Nile+Campaign.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/Environmental+Heroes+Clean+Up+the+Nile+Campaign.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 946,
                name: "She was forced out of Egypt because ...",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/She+was+forced+out+of+Egypt+because+....mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/She+was+forced+out+of+Egypt+because+....png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 947,
                name: "Save lives",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/Save+lives.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/Save+lives.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 948,
                name: "I was able to remove the Mongolian bell from the curriculum of Egypt",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/I+was+able+to+remove+the+Mongolian+bell+from+the+curriculum+of+Egypt.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/I+was+able+to+remove+the+Mongolian+bell+from+the+curriculum+of+Egypt.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 949,
                name: "Discover the abandoned aircraft dealer arms",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/Discover+the+abandoned+aircraft+dealer+arms.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/Discover+the+abandoned+aircraft+dealer+arms.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 950,
                name: "The next Olympic Russian ski champion",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/The+next+Olympic+Russian+ski+champion.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/The+next+Olympic+Russian+ski+champion.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 951,
                name: "Revolving house",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/Revolving+house.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/Revolving+house.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 952,
                name: "Clean energy storage",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/Clean+energy+storage.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/Clean+energy+storage.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 954,
                name: "Ramadan becomes vegetarian with the new generation",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/Ramadan+becomes+vegetarian+with+the+new+generation.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/Ramadan+becomes+vegetarian+with+the+new+generation.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 955,
                name: "Science on the road to change",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/Science+on+the+road+to+change.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/Science+on+the+road+to+change.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 956,
                name: "I was afraid to say people do not go out before you say Subhanallah",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/I+was+afraid+to+say+people+do+not+go+out+before+you+say+Subhanallah.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/I+was+afraid+to+say+people+do+not+go+out+before+you+say+Subhanallah.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 957,
                name: "Life Coach",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/Life+Coach.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/Life+Coach.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 958,
                name: "Maniacers are proud of the role-playing player",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/Maniacers+are+proud+of+the+role-playing+player.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/Maniacers+are+proud+of+the+role-playing+player.png",
                filename: ""
            },
            {
                category: "Motivation",
                id: 959,
                name: "We don't need pity from anyone",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/motivation/We+don't+need+pity+from+anyone.mp4",
                preview: "https://cdn.mobiotv.com/sa/motivation/We+don't+need+pity+from+anyone.png",
                filename: ""
            }
        ]
    },
    {
        id: 2,
        contents: 7,
        name: {
            en: "Tour",
            be: "Tour",
            id: "Tour",
            it: "Tour",
            se: "Tour",
            ar: "جولة"
        },
        videos: [{
                category: "Tour",
                id: 960,
                name: "The most beautiful villages of Andalusia",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/tour/The+most+beautiful+villages+of+Andalusia.mp4",
                preview: "https://cdn.mobiotv.com/sa/tour/The+most+beautiful+villages+of+Andalusia.png",
                filename: ""
            },
            {
                category: "Tour",
                id: 961,
                name: "Victoria's coolest waterfalls",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/tour/Victoria's+coolest+waterfalls.mp4",
                preview: "https://cdn.mobiotv.com/sa/tour/Victoria's+coolest+waterfalls.png",
                filename: ""
            },
            {
                category: "Tour",
                id: 962,
                name: "High temple views over the cliff",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/tour/High+temple+views+over+the+cliff.mp4",
                preview: "https://cdn.mobiotv.com/sa/tour/High+temple+views+over+the+cliff.png",
                filename: ""
            },
            {
                category: "Tour",
                id: 963,
                name: "High views of the canal walkway",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/tour/High+views+of+the+canal+walkway.mp4",
                preview: "https://cdn.mobiotv.com/sa/tour/High+views+of+the+canal+walkway.png",
                filename: ""
            },
            {
                category: "Tour",
                id: 964,
                name: "Innovations of the Upper Garden Cities",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/tour/Innovations+of+the+Upper+Garden+Cities.mp4",
                preview: "https://cdn.mobiotv.com/sa/tour/Innovations+of+the+Upper+Garden+Cities.png",
                filename: ""
            },
            {
                category: "Tour",
                id: 965,
                name: "Restaurants Mr. Stacks",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/tour/Restaurants+Mr.+Stacks.mp4",
                preview: "https://cdn.mobiotv.com/sa/tour/Restaurants+Mr.+Stacks.png",
                filename: ""
            },
            {
                category: "Tour",
                id: 966,
                name: "Avocado Gallery",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/tour/Avocado+Gallery.mp4",
                preview: "https://cdn.mobiotv.com/sa/tour/Avocado+Gallery.png",
                filename: ""
            }
        ]
    },
    {
        id: 3,
        contents: 5,
        name: {
            en: "Fun Gaming",
            be: "Fun Gaming",
            id: "Fun Gaming",
            it: "Fun Gaming",
            se: "Fun Gaming",
            ar: "متعة الألعاب"
        },
        videos: [{
                category: "Fun Gaming",
                id: 967,
                name: "Get to know this Jake Lock",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/fungaming/Get+to+know+this+Jake+Lock.mp4",
                preview: "https://cdn.mobiotv.com/sa/fungaming/Get+to+know+this+Jake+Lock.png",
                filename: ""
            },
            {
                category: "Fun Gaming",
                id: 968,
                name: "Games Culture Dubai eSports Center",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/fungaming/Games+Culture+Dubai+eSports+Center.mp4",
                preview: "https://cdn.mobiotv.com/sa/fungaming/Games+Culture+Dubai+eSports+Center.png",
                filename: ""
            },
            {
                category: "Fun Gaming",
                id: 969,
                name: "How to become a legend in the world of games?",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/fungaming/How+to+become+a+legend+in+the+world+of+games%3F.mp4",
                preview: "https://cdn.mobiotv.com/sa/fungaming/How+to+become+a+legend+in+the+world+of+games%3F.png",
                filename: ""
            },
            {
                category: "Fun Gaming",
                id: 970,
                name: "Prof. Gamers",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/fungaming/Prof.+Gamers.mp4",
                preview: "https://cdn.mobiotv.com/sa/fungaming/Prof.+Gamers.png",
                filename: ""
            },
            {
                category: "Fun Gaming",
                id: 971,
                name: "Gamers assistant coach",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/fungaming/Gamers+assistant+coach.mp4",
                preview: "https://cdn.mobiotv.com/sa/fungaming/Gamers+assistant+coach.png",
                filename: ""
            }
        ]
    },
    {
        id: 4,
        contents: 3,
        name: {
            en: "Athletics",
            be: "Athletics",
            id: "Athletics",
            it: "Athletics",
            se: "Athletics",
            ar: "ألعاب القوى"
        },
        videos: [{
                category: "Athletics",
                id: 972,
                name: "The best football players Joao Felix",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/athletics/The+best+football+players+Joao+Felix.mp4",
                preview: "https://cdn.mobiotv.com/sa/athletics/The+best+football+players+Joao+Felix.png",
                filename: ""
            },
            {
                category: "Athletics",
                id: 973,
                name: "Hijabi does not obscure my dreams volleyball",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/athletics/Hijabi+does+not+obscure+my+dreams+volleyball.mp4",
                preview: "https://cdn.mobiotv.com/sa/athletics/Hijabi+does+not+obscure+my+dreams+volleyball.png",
                filename: ""
            },
            {
                category: "Athletics",
                id: 974,
                name: "Spain's fast runner",
                desc: "",
                duration: "",
                videoUrl: "https://cdn.mobiotv.com/sa/athletics/Spain%27s+fast+runner.mp4",
                preview: "https://cdn.mobiotv.com/sa/athletics/Spain%27s+fast+runner.png",
                filename: ""
            }
        ]
    },
    {
        id: 9,
        contents: 9,
        name: {
            en: "Inspiration",
            be: "Inspiratie",
            id: "Inspiration",
            it: "Ispirazione",
            se: "Inspiration",
            ar: "الهام"
        },
        videos: [{
                duration: "Watch Now",
                id: 906,
                name: "An Influencer's Calling 'Everyone had to accept me when I accepted myself'",
                preview: "https://cdn.mobiotv.com/bidiotv/Inspiration/An+Influencer's+Calling+'Everyone+had+to+accept+me+when+I+accepted+myself'.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Inspiration/An+Influencer's+Calling+'Everyone+had+to+accept+me+when+I+accepted+myself'.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 907,
                name: "Crazy Cravings 'When I'm behind my mask, I'm basically someone new'",
                preview: "https://cdn.mobiotv.com/bidiotv/Inspiration/Crazy+Cravings+'When+I'm+behind+my+mask%2C+I'm+basically+someone+new'.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Inspiration/Crazy+Cravings+'When+I'm+behind+my+mask%2C+I'm+basically+someone+new'.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 908,
                name: "I'm a Celebrity Pet Luna is a prickly up-and-comer",
                preview: "https://cdn.mobiotv.com/bidiotv/Inspiration/I'm+a+Celebrity+Pet+Luna+is+a+prickly+up-and-comer.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Inspiration/I'm+a+Celebrity+Pet!+Luna+is+a+prickly+up-and-comer.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 909,
                name: "Inspire in a minute The supermodel discovered at 60",
                preview: "https://cdn.mobiotv.com/bidiotv/Inspiration/Inspire+in+a+minute+The+supermodel+discovered+at+60.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Inspiration/Inspire+in+a+minute+The+supermodel+discovered+at+60.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 911,
                name: "My Cool School Camilla's studying the trapeze",
                preview: "https://cdn.mobiotv.com/bidiotv/Inspiration/My+Cool+School+Camilla's+studying+the+trapeze.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Inspiration/My+Cool+School+Camilla's+studying+the+trapeze.mp4",
                filename: ""
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 912,
            //     "name": "My Social Media Activism Reminding others they aren't alone",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Inspiration/My+Social+Media+Activism+It's+time+for+everyone+to+%23FillTheBottle.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Inspiration/My+Social+Media+Activism+It's+time+for+everyone+to+%23FillTheBottle.mp4",
            //     "filename":"",
            // },
            {
                duration: "Watch Now",
                id: 913,
                name: "The pilots flying a restored WWII plane around the world",
                preview: "https://cdn.mobiotv.com/bidiotv/Inspiration/The+pilots+flying+a+restored+WWII+plane+around+the+world.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Inspiration/The+pilots+flying+a+restored+WWII+plane+around+the+world.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 914,
                name: "Young CEO 'When I look at a camera, I see power in me & I see greatness",
                preview: "https://cdn.mobiotv.com/bidiotv/Inspiration/Young+CEO+'When+I+look+at+a+camera%2C+I+see+power+in+me+%26+I+see+greatness'.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Inspiration/Young+CEO+'When+I+look+at+a+camera%2C+I+see+power+in+me+%26+I+see+greatness'.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 10,
        contents: 5,
        name: {
            en: "Into Nature",
            be: "Natuur",
            id: "Natur",
            it: "Natura",
            se: "Into Nature",
            ar: "في الطبيعة"
        },
        videos: [{
                duration: "Watch Now",
                id: 915,
                name: "City Innovations The higher you go, the greener it gets",
                preview: "https://cdn.mobiotv.com/bidiotv/Into+Nature/City+Innovations+The+higher+you+go%2C+the+greener+it+gets.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Into+Nature/City+Innovations+The+higher+you+go%2C+the+greener+it+gets.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 916,
                name: "Green Heroes The urban experience just got a sustainable upgrade",
                preview: "https://cdn.mobiotv.com/bidiotv/Into+Nature/Green+Heroes+The+urban+experience+just+got+a+sustainable+upgrade.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Into+Nature/Green+Heroes+The+urban+experience+just+got+a+sustainable+upgrade.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 917,
                name: "Inspire in a Minute From bullied bug hunter to kid author",
                preview: "https://cdn.mobiotv.com/bidiotv/Into+Nature/Inspire+in+a+Minute+From+bullied+bug+hunter+to+kid+author.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Into+Nature/Inspire+in+a+Minute+From+bullied+bug+hunter+to+kid+author.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 918,
                name: "Sights with Heights Ghana’s national park canopy walk",
                preview: "https://cdn.mobiotv.com/bidiotv/Into+Nature/Sights+with+Heights+Ghana%E2%80%99s+national+park+canopy+walk.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Into+Nature/Sights+with+Heights+Ghana%E2%80%99s+national+park+canopy+walk.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 919,
                name: "Sights with Heights The cliff side sanctuary between heaven and earth",
                preview: "https://cdn.mobiotv.com/bidiotv/Into+Nature/Sights+with+Heights+The+cliff+side+sanctuary+between+heaven+and+earth.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Into+Nature/Sights+with+Heights+The+cliff+side+sanctuary+between+heaven+and+earth.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 11,
        contents: 19,
        name: {
            en: "Political & Activism",
            be: "Politiek activisme",
            id: "Politisk & aktivism",
            it: "Politico e attivismo",
            se: "Political & Activism",
            ar: "النشاط السياسي"
        },
        videos: [{
                duration: "Watch Now",
                id: 920,
                name: "A place to call home for abandoned dogs",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/A+place+to+call+home+for+abandoned+dogs.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/A+place+to+call+home+for+abandoned+dogs.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 921,
                name: "Barry the bee whisperer’s most important fight yet",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Barry+the+bee+whisperer%E2%80%99s+most+important+fight+yet.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Barry+the+bee+whisperer%E2%80%99s+most+important+fight+yet.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 922,
                name: "CEO activism is on the rise",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/CEO+activism+is+on+the+rise.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/CEO+activism+is+on+the+rise.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 923,
                name: "Indigenous Heroes Nigeria's Elijah is seeking legal justice for his people",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indigenous+Heroes+Nigeria's+Elijah+is+seeking+legal+justice+for+his+people.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indigenous+Heroes+Nigeria's+Elijah+is+seeking+legal+justice+for+his+people.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 924,
                name: "Indonesia to build a new capital due to climate change",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indonesia+to+build+a+new+capital+due+to+climate+change.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indonesia+to+build+a+new+capital+due+to+climate+change.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 925,
                name: "Inspire in a Minute Breaking Borders is a tour you have to go on",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Breaking+Borders+is+a+tour+you+have+to+go+on.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Breaking+Borders+is+a+tour+you+have+to+go+on.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 926,
                name: "Inspire in a Minute Fighting menstrual stigma in Nepal",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Fighting+menstrual+stigma+in+Nepal.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Fighting+menstrual+stigma+in+Nepal.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 927,
                name: "Inspire in a Minute Helping kids fight back & get better",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Helping+kids+fight+back+%26+get+better.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Helping+kids+fight+back+%26+get+better.mp4",
                filename: ""
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 928,
            //     "name": "Inspire in a Minute War Workout Warriors",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+War+Workout+Warriors.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+War+Workout+Warriors.mp4",
            //     "filename":"",
            // },
            {
                duration: "Watch Now",
                id: 930,
                name: "More than half of world’s forest wildlife disappeared",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indonesia+to+build+a+new+capital+due+to+climate+change.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indonesia+to+build+a+new+capital+due+to+climate+change.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 931,
                name: "My Social Media Activism It's time for everyone to #FillTheBottle",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/My+Social+Media+Activism+It's+time+for+everyone+to+%23FillTheBottle.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/My+Social+Media+Activism+It's+time+for+everyone+to+%23FillTheBottle.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 932,
                name: "Peace Builders Closing the cycle of violence",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+Closing+the+cycle+of+violence.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+Closing+the+cycle+of+violence.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 933,
                name: "Peace Builders The Art of Peaceful Resistance",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+The+Art+of+Peaceful+Resistance.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+The+Art+of+Peaceful+Resistance.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 935,
                name: "Peace Builders The uniting factor that's bringing people together",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+The+uniting+factor+that's+bringing+people+together.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+The+uniting+factor+that's+bringing+people+together.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 938,
                name: "The results are in, Tokyo is the safest city in the world",
                preview: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/The+results+are+in%2C+Tokyo+is+the+safest+city+in+the+world.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/The+results+are+in%2C+Tokyo+is+the+safest+city+in+the+world!.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 12,
        contents: 5,
        name: {
            en: "Travel",
            be: "Reizen",
            id: "Resa",
            it: "Viaggio",
            se: "Travel",
            ar: "السفر"
        },
        videos: [{
                duration: "Watch Now",
                id: 939,
                name: "Amazing Waterfalls Zambia's jaw-dropping natural wonder",
                preview: "https://cdn.mobiotv.com/bidiotv/Travel/Amazing+Waterfalls+Zambia's+jaw-dropping+natural+wonder.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Travel/Amazing+Waterfalls+Zambia's+jaw-dropping+natural+wonder.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 940,
                name: "Fairy tale dream spots The prettiest village in Andalucía",
                preview: "https://cdn.mobiotv.com/bidiotv/Travel/Fairy+Tale+Dream+Spots+The+sinking+castle+of+Scaligera.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Travel/Fairy+Tale+Dream+Spots+The+sinking+castle+of+Scaligera.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 941,
                name: "Fairy Tale Dream Spots The sinking castle of Scaligera",
                preview: "https://cdn.mobiotv.com/bidiotv/Travel/Fairy+tale+dream+spots+The+prettiest+village+in+Andaluci%CC%81a.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Travel/Fairy+tale+dream+spots+The+prettiest+village+in+Andaluci%CC%81a.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 942,
                name: "Medellín is the backpacking spot you've been looking for",
                preview: "https://cdn.mobiotv.com/bidiotv/Travel/Medelli%CC%81n+is+the+backpacking+spot+you've+been+looking+for.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Travel/Medelli%CC%81n+is+the+backpacking+spot+you've+been+looking+for.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 943,
                name: "Sights with Heights The narrow bridges of Caminito del Rey",
                preview: "https://cdn.mobiotv.com/bidiotv/Travel/Sights+with+Heights+The+narrow+bridges+of+Caminito+del+Rey.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Travel/Sights+with+Heights+The+narrow+bridges+of+Caminito+del+Rey.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 944,
                name: "This Dutch parade takes flower power to the next level",
                preview: "https://cdn.mobiotv.com/bidiotv/Travel/This+Dutch+parade+takes+flower+power+to+the+next+level.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Travel/This+Dutch+parade+takes+flower+power+to+the+next+level.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 13,
        contents: 3,
        name: {
            en: "Foodbuzz",
            be: "Foodbuzz",
            id: "Foodbuzz",
            it: "Foodbuzz",
            se: "Foodbuzz",
            ar: "الطعام"
        },
        videos: [{
                duration: "Watch Now",
                id: 901,
                name: "Insta Restaurant We could all use a bit more pink in our lives",
                preview: "https://cdn.mobiotv.com/bidiotv/Foodbuzz/Insta+Restaurant+We+could+all+use+a+bit+more+pink+in+our+lives.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Foodbuzz/Insta+Restaurant+We+could+all+use+a+bit+more+pink+in+our+lives.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 902,
                name: "KFC is testing meatless chicken wings and nuggets",
                preview: "https://cdn.mobiotv.com/bidiotv/Foodbuzz/KFC+is+testing+meatless+chicken+wings+and+nuggets.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Foodbuzz/KFC+is+testing+meatless+chicken+wings+and+nuggets.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 903,
                name: "Turning leftover bread into panzanella & bruschetta caprese",
                preview: "https://cdn.mobiotv.com/bidiotv/Foodbuzz/Turning+leftover+bread+into+panzanella+%26+bruschetta+caprese.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Foodbuzz/Turning+leftover+bread+into+panzanella+%26+bruschetta+caprese.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 805,
                name: "Salsas for Sunny Days Spicy mango salsa",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/Salsas+for+Sunny+Days+Spicy+mango+salsa.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/Salsas+for+Sunny+Days+Spicy+mango+salsa.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 806,
                name: "Vegan Ice Cream Avocado Banana",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Avocado+Banana.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Avocado+Banana.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 807,
                name: "Vegan Ice Cream Banana Matcha",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Banana+Matcha.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Banana+Matcha.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 808,
                name: "Vegan Ice Cream Coconut Fusion",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Coconut+Fusion.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Coconut+Fusion.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 809,
                name: "Vegan Ice Cream Fresh Fruit Popsicles",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Fresh+Fruit+Popsicles.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Fresh+Fruit+Popsicles.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 810,
                name: "Vegan Ice Cream Pineapple Mint Lime",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Pineapple+Mint+Lime.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Pineapple+Mint+Lime.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 58,
        contents: 12,
        name: {
            en: "Entertainment",
            ar: "الترفيهية"
        },
        videos: [{
                duration: "Watch Now",
                id: 5801,
                name: "Are you of the 1.7 million who downloaded Quibi",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/Are-you-of-the-1.7-million-who-downloaded-Quibi.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/Are+you+of+the+1.7+million+who+downloaded+Quibi.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 5802,
                name: "Cleaning up beaches and creating art, one butt at a time",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/Cleaning-up-beaches-and-creating-art%2C-one-butt-at-a-time.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/Cleaning+up+beaches+and+creating+art%2C+one+butt+at+a+time.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 5803,
                name: "Five Fun facts about Mean Girls Broadway star Sabrina Carpenter",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/Five-Fun-facts-about-Mean-Girls-Broadway-star-Sabrina-Carpenter.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/Five+Fun+facts+about+Mean+Girls+Broadway+star+Sabrina+Carpenter.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 5804,
                name: "How to photo transfer anything A wooden gift for mom",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/How-to-photo-transfer-anything-A-wooden-gift-for-mom.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/How+to+photo+transfer+anything+A+wooden+gift+for+mom.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 5805,
                name: "How to Photo Transfer Anything Images on rocks made easy",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/How-to-Photo-Transfer-Anything-Images-on-rocks-made-easy.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/How+to+Photo+Transfer+Anything+Images+on+rocks+made+easy.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 5806,
                name: "How to Photo Transfer Anything Screen printing made easy",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/How-to-Photo-Transfer-Anything-Screen-printing-made-easy.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/How+to+Photo+Transfer+Anything+Screen+printing+made+easy.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 5807,
                name: "One man's mission to get the wheels turning in Colombia",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/One-man's-mission-to-get-the-wheels-turning-in-Colombia.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/One+man's+mission+to+get+the+wheels+turning+in+Colombia.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 5808,
                name: "Online Life How these creatives are staying inspired during lockdown",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/Online-Life-How-these-creatives-are-staying-inspired-during-lockdown.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/Online+Life+How+these+creatives+are+staying+inspired+during+lockdown.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 5809,
                name: "Online Life How this dancer's turning adversity into opportunity",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/Online-Life-How-this-dancer's-turning-adversity-into-opportunity.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/Online+Life+How+this+dancer's+turning+adversity+into+opportunity.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 5810,
                name: "Online Life Tips from a teacher who's gone digital during lockdown",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/Online-Life-Tips-from-a-teacher-who's-gone-digital-during-lockdown.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/Online+Life+Tips+from+a+teacher+who's+gone+digital+during+lockdown.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 5811,
                name: "Seth Rogen's 5 most comforting comedies to watch now",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/Seth-Rogen's-5-most-comforting-comedies-to-watch-now.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/Seth+Rogen's+5+most+comforting+comedies+to+watch+now.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 5812,
                name: "The Zoom blind dating service all singles should know about",
                preview: "https://cdn.mobiotv.com/bidiotv/Entertainment/The-Zoom-blind-dating-service-all-singles-should-know-about.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Entertainment/The+Zoom+blind+dating+service+all+singles+should+know+about.mp4",
                filename: ""
            },
        ]
    },
    {
        id: 14,
        contents: 2,
        name: {
            en: "Health and Nutrition",
            be: "Gezondheid & Voeding",
            id: "Hälsa och näring",
            it: "Salute e Nutrizione",
            se: "Health and Nutrition",
            ar: "الصحة والتغذية"
        },
        videos: [{
                duration: "Watch Now",
                id: 1906,
                name: "Level up your fitness and relationship with these acroyoga moves",
                preview: "https://cdn.mobiotv.com/bidiotv/Health/Level-up-your-fitness-and-relationship-with-these-acroyoga-moves.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Health/Level+up+your+fitness+and+relationship+with+these+acroyoga+moves.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 1907,
                name: "Life Boost Influencers- Roz the diva will make you sweat and smile",
                preview: "https://cdn.mobiotv.com/bidiotv/Health/Life-Boost-Influencers--Roz-the-diva-will-make-you-sweat-and-smile.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Health/Life+Boost+Influencers-+Roz+the+diva+will+make+you+sweat+and+smile.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 1908,
                name: "Life Boost Influencers- The ASMR-tist helping quarantined fans relax",
                preview: "https://cdn.mobiotv.com/bidiotv/Health/Life-Boost-Influencers--The-ASMR-tist-helping-quarantined-fans-relax.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Health/Life+Boost+Influencers-+The+ASMR-tist+helping+quarantined+fans+relax.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 1909,
                name: "Shay Mitchell is quarantining just like us- with wine and a yoga mat",
                preview: "https://cdn.mobiotv.com/bidiotv/Health/Shay-Mitchell-is-quarantining-just-like-us-with-wine-and-a-yoga-mat.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Health/Shay+Mitchell+is+quarantining+just+like+us-+with+wine+and+a+yoga+mat.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 1910,
                name: "The Colombian prison that lets inmates get a taste of freedom and nature",
                preview: "https://cdn.mobiotv.com/bidiotv/Health/The-Colombian-prison-that-lets-inmates-get-a-taste-of-freedom-and-nature.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Health/The+Colombian+prison+that+lets+inmates+get+a+taste+of+freedom+and+nature.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 1911,
                name: "TV doctors have a video message for real doctors",
                preview: "https://cdn.mobiotv.com/bidiotv/Health/TV-doctors-have-a-video-message-for-real-doctors.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Health/TV+doctors+have+a+video+message+for+real+doctors.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 904,
                name: "Brain implants are closer than you might think...",
                preview: "https://cdn.mobiotv.com/bidiotv/Health+and+Nutrition/Brain+implants+are+closer+than+you+might+think....jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Health+and+Nutrition/Brain+implants+are+closer+than+you+might+think....mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 905,
                name: "Thanks, Chameleons Humans might get color-changing skin",
                preview: "https://cdn.mobiotv.com/bidiotv/Health+and+Nutrition/Thanks%2C+Chameleons+Humans+might+get+color-changing+skin.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Health+and+Nutrition/Thanks%2C+Chameleons+Humans+might+get+color-changing+skin.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 15,
        contents: 24,
        name: {
            en: "Fitness",
            be: "Fitness",
            id: "Kebugaran",
            it: "Fitness",
            se: "Fitness",
            ar: "اللياقه البدنيه"
        },
        videos: [{
                duration: "Watch Now",
                id: 1,
                name: "Arm and Leg Raise",
                preview: "https://cdn.mobiotv.com/bidiotv/Fitness/Arm+and+Leg+Raise.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fitness/Arm+and+Leg+Raise.mp4",
                filename: "bidiotv/Fitness/Arm+and+Leg+Raise.mp4"
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 2,
            //     "name": "Attack and Defense",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Attack+and+Defense.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.bidiotv.com/Fitness/Attack+and+Defense.mp4",
            //     "filename":"bidiotv/Fitness/Attack+and+Defense.mp4",
            // },
            {
                duration: "Watch Now",
                id: 3,
                name: "Condition training",
                preview: "https://cdn.mobiotv.com/bidiotv/Fitness/Condition+training.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fitness/Condition+training.mp4",
                filename: "bidiotv/Fitness/Condition+training.mp4"
            },
            {
                duration: "Watch Now",
                id: 4,
                name: "Core Strength",
                preview: "https://cdn.mobiotv.com/bidiotv/Fitness/Core+strength.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fitness/Core+strength.mp4",
                filename: "bidiotv/Fitness/Core+strength.mp4"
            },
            {
                duration: "Watch Now",
                id: 5,
                name: "Lunges",
                preview: "https://cdn.mobiotv.com/bidiotv/Fitness/Lunges.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fitness/Lunges.mp4",
                filename: "bidiotv/Fitness/Lunges.mp4"
            },
            {
                duration: "Watch Now",
                id: 6,
                name: "Punch Bag",
                preview: "https://cdn.mobiotv.com/bidiotv/Fitness/Punch+Bag.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fitness/Punch+Bag.mp4",
                filename: "bidiotv/Fitness/Punch+Bag.mp4"
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 7,
            //     "name": "Push Ups",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Push+Ups.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.bidiotv.com/Fitness/Push+Ups.mp4",
            //     "filename":"bidiotv/Fitness/Push+Ups.mp4",
            // },
            // {
            //     "duration": "Watch Now",
            //     "id": 8,
            //     "name": "Russian Kicks",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Russian+Kicks.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.bidiotv.com/Fitness/Russian+Kicks.mp4",
            //     "filename":"bidiotv/Fitness/Russian+Kicks.mp4",
            // },
            {
                duration: "Watch Now",
                id: 9,
                name: "Shadow Boxing",
                preview: "https://cdn.mobiotv.com/bidiotv/Fitness/Shadowboxing.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fitness/Shadowboxing.mp4",
                filename: "bidiotv/Fitness/Shadowboxing.mp4"
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 10,
            //     "name": "Sit Ups",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Sit+Ups.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.bidiotv.com/Fitness/Sit+Ups.mp4",
            //     "filename":"bidiotv/Fitness/Sit+Ups.mp4",
            // },
            {
                duration: "Watch Now",
                id: 11,
                name: "Stretching",
                preview: "https://cdn.mobiotv.com/bidiotv/Fitness/Stretching.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fitness/Stretching.mp4",
                filename: "bidiotv/Fitness/Stretching.mp4"
            }
            // {
            //     "duration": "Watch Now",
            //     "id": 12,
            //     "name": "The Plank",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/The+Plank.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.bidiotv.com/Fitness/The+Plank.mp4",
            //     "filename":"bidiotv/Fitness/The+Plank.mp4",

            // },
            // {
            //     "duration": "Watch Now",
            //     "id": 13,
            //     "name": "Tricep Dips",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Tricep+Dips.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.bidiotv.com/Fitness/Tricep+Dips.mp4",
            //     "filename":"bidiotv/Fitness/Tricep+Dips.mp4",
            // },
        ]
    },
    {
        id: 16,
        contents: 24,
        name: {
            en: "Top Cars",
            be: "Top Auto's",
            id: "Mobil Terbaik",
            it: "Le migliori auto",
            se: "Bästa bilarna",
            ar: "أفضل السيارات"
        },
        videos: [{
                duration: "Watch Now",
                id: 24,
                name: "2016 Chevrolet Camaro SS",
                preview: "https://cdn.mobiotv.com/bidiotv/Top+Gear/2016+Chevrolet+Camaro+SS.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Top+Gear/2016+Chevrolet+Camaro+SS.mp4",
                filename: "bidiotv/Top+Gear/2016+Chevrolet+Camaro+SS.mp4"
            },
            {
                duration: "Watch Now",
                id: 25,
                name: "2016 Ford Mustang Fastback",
                preview: "https://cdn.mobiotv.com/bidiotv/Top+Gear/2016+Ford+Mustang+Fastback.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Top+Gear/2016+Ford+Mustang+Fastback.mp4",
                filename: "bidiotv/Top+Gear/2016+Ford+Mustang+Fastback.mp4"
            },
            {
                duration: "Watch Now",
                id: 26,
                name: "2016 Ford Mustang GT4",
                preview: "https://cdn.mobiotv.com/bidiotv/Top+Gear/2016+Ford+Mustang+GT4.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Top+Gear/2016+Ford+Mustang+GT4.mp4",
                filename: "bidiotv/Top+Gear/2016+Ford+Mustang+GT4.mp4"
            },
            {
                duration: "Watch Now",
                id: 27,
                name: "2016 Toyota Prius G Racing Car",
                preview: "https://cdn.mobiotv.com/bidiotv/Top+Gear/2016+Toyota+Xtreme+Corolla.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Top+Gear/2016+Toyota+Prius+G+Racing+Car.mp4",
                filename: "bidiotv/Top+Gear/2016+Toyota+Prius+G+Racing+Car.mp4"
            },
            {
                duration: "Watch Now",
                id: 28,
                name: "2016 Toyota Xtreme Corolla",
                preview: "https://cdn.mobiotv.com/bidiotv/Top+Gear/2016+Toyota+Prius+G+Racing+Car.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Top+Gear/2016+Toyota+Xtreme+Corolla.mp4",
                filename: "bidiotv/Top+Gear/2016+Toyota+Xtreme+Corolla.mp4"
            }
        ]
    },
    {
        id: 17,
        contents: 24,
        name: {
            en: "Fashion & Beauty",
            be: "Mode & Schoonheid",
            id: "Fashion & Kecantikan",
            it: "Moda e bellezza",
            se: "Mode & skönhet",
            ar: "الجمال الأزياء"
        },
        videos: [{
                duration: "Watch Now",
                id: 29,
                name: "Glamorous Touch",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Glamorous+Touch.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fashion+%26+Beauty/Glamorous+Touch.mp4",
                filename: "bidiotv/Fashion+%26+Beauty/Glamorous+Touch.mp4"
            },
            {
                duration: "Watch Now",
                id: 30,
                name: "Lips Glamorous Red",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Lips+Glamorous+Red.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fashion+%26+Beauty/Lips+Glamorous+Red.mp4",
                filename: "bidiotv/Fashion+%26+Beauty/Lips+Glamorous+Red.mp4"
            },
            {
                duration: "Watch Now",
                id: 31,
                name: "Lips Natural",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Lips+Natural.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fashion+%26+Beauty/Lips+Natural.mp4",
                filename: "bidiotv/Fashion+%26+Beauty/Lips+Natural.mp4"
            },
            {
                duration: "Watch Now",
                id: 32,
                name: "Lips Sparkling and Full",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Lips+Sparkling+and+Full.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fashion+%26+Beauty/Lips+Sparkling+and+Full.mp4",
                filename: "bidiotv/Fashion+%26+Beauty/Lips+Sparkling+and+Full.mp4"
            },
            {
                duration: "Watch Now",
                id: 33,
                name: "Make-Up Blush",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make-Up+Blush.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fashion+%26+Beauty/Make-Up+Blush.mp4",
                filename: "bidiotv/Fashion+%26+Beauty/Make-Up+Blush.mp4"
            },
            {
                duration: "Watch Now",
                id: 34,
                name: "Make-Up Bronzer",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make-Up+Bronzer.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fashion+%26+Beauty/Make-Up+Bronzer.mp4",
                filename: "bidiotv/Fashion+%26+Beauty/Make-Up+Bronzer.mp4"
            },
            {
                duration: "Watch Now",
                id: 35,
                name: "Make-Up Concealer",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make-Up+Concealer.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fashion+%26+Beauty/Make-Up+Concealer.mp4",
                filename: "bidiotv/Fashion+%26+Beauty/Make-Up+Concealer.mp4"
            },
            {
                duration: "Watch Now",
                id: 36,
                name: "Make-Up Eyebrows",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make-Up+Eyebrows.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fashion+%26+Beauty/Make-Up+Eyebrows.mp4",
                filename: "bidiotv/Fashion+%26+Beauty/Make-Up+Eyebrows.mp4"
            },
            {
                duration: "Watch Now",
                id: 37,
                name: "Make-Up Foundation",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make-Up+Foundation.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fashion+%26+Beauty/Make-Up+Foundation.mp4",
                filename: "bidiotv/Fashion+%26+Beauty/Make-Up+Foundation.mp4"
            },
            {
                duration: "Watch Now",
                id: 38,
                name: "Smokey Eyes",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Smokey+Eyes.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fashion+%26+Beauty/Smokey+Eyes.mp4",
                filename: "bidiotv/Fashion+%26+Beauty/Smokey+Eyes.mp4"
            },
            {
                duration: "Watch Now",
                id: 39,
                name: "Sparkling Eyes",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Sparkling+Eyes.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Fashion+%26+Beauty/Sparkling+Eyes.mp4",
                filename: "bidiotv/Fashion+%26+Beauty/Sparkling+Eyes.mp4"
            },
            {
                duration: "Watch Now",
                id: 140,
                name: "5 Make up tips and Tricks for you",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/5+Make+up+tips+and+Tricks+for+you.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/5+Make+up+tips+and+Tricks+for+you.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 141,
                name: "7 Make up tips and tricks for flawless skin",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/7+Make+up+tips+and+tricks+for+flawless+skin.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/7+Make+up+tips+and+tricks+for+flawless+skin.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 142,
                name: "10 Fast and easy make up tips",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/10+Fast+and+easy+make+up+tips.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/10+Fast+and+easy+make+up+tips.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 143,
                name: "10 Make up tips and tricks for Oily Skin",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/10+Make+up+tips+and+tricks+for+Oily+Skin.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/10+Make+up+tips+and+tricks+for+Oily+Skin.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 144,
                name: "13 Make up mistakes to avoid",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/13+Make+up+mistakes+to+avoid.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/13+Make+up+mistakes+to+avoid.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 145,
                name: "101 Tips for beginner make up",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/101+Tips+for+beginner+make+up.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/101+Tips+for+beginner+make+up.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 146,
                name: "Asian beauty tips you must do now",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Asian+beauty+tips+you+must+do+now.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Asian+beauty+tips+you+must+do+now.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 147,
                name: "Beginner every make up tips and tricks for you",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Beginner+every+make+up+tips+and+tricks+for+you.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Beginner+every+make+up+tips+and+tricks+for+you.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 148,
                name: "Best make up artist tips you need to know",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Best+make+up+artist+tips+you+need+to+know.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Best+make+up+artist+tips+you+need+to+know.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 149,
                name: "Essential make up tips for summer glow",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Essential+make+up+tips+for+summer+glow.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Essential+make+up+tips+for+summer+glow.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 150,
                name: "Flattering eyes make up for you",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Flattering+eyes+make+up+for+you.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Flattering+eyes+make+up+for+you.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 151,
                name: "Foundation tricks for oily Skin",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Foundation+tricks+for+oily+Skin.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Foundation+tricks+for+oily+Skin.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 152,
                name: "Full coverage foundation routine for you",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Full+coverage+foundation+routine+for+you.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Full+coverage+foundation+routine+for+you.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 153,
                name: "Look Fierce with drugstore make up",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Look+Fierce+with+drugstore+make+up.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Look+Fierce+with+drugstore+make+up.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 154,
                name: "Make up essentials for dark skin tones",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+essentials+for+dark+skin+tones.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+essentials+for+dark+skin+tones.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 155,
                name: "Make up tips for aging eyes",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+tips+for+aging+eyes.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+tips+for+aging+eyes.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 156,
                name: "Make up tips for flawless skin",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+tips+for+flawless+skin.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+tips+for+flawless+skin.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 157,
                name: "Must know make up tips",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Must+know+make+up+tips.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Must+know+make+up+tips.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 158,
                name: "Must know wake up tips",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Must+know+wake+up+tips.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Must+know+wake+up+tips.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 159,
                name: "Natural make up korean style",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+make+up+korean+style.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+make+up+korean+style.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 160,
                name: "Natural make up tips for men",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+make+up+tips+for+men.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+make+up+tips+for+men.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 161,
                name: "Natural to Glamorous",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+to+Glamorous.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+to+Glamorous.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 162,
                name: "Over 40 aged woman make up tips",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Over+40+aged+woman+make+up+tips.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Over+40+aged+woman+make+up+tips.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 163,
                name: "Pro make up tips by Tati",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Pro+make+up+tips+by+Tati.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Pro+make+up+tips+by+Tati.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 164,
                name: "Secret Make up tips and tricks for beginners",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Secret+Make+up+tips+and+tricks+for+beginners.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Secret+Make+up+tips+and+tricks+for+beginners.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 165,
                name: "Simple Tips for Eyeshadow",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Simple+Tips+for+Eyeshadow.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Simple+Tips+for+Eyeshadow.mp4",
                filename: ""
            },

            {
                duration: "Watch Now",
                id: 166,
                name: "Summer make up meltproof tips",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Summer+make+up+meltproof+tips.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Summer+make+up+meltproof+tips.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 167,
                name: "Top 10 secret tips of celebrities",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Top+10+secret+tips+of+celebrities.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Top+10+secret+tips+of+celebrities.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 168,
                name: "Top 25 make up tips for pale skin",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Top+25+make+up+tips+for+pale+skin.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Top+25+make+up+tips+for+pale+skin.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 169,
                name: "Tyra Banks make up tips",
                preview: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Tyra+Banks+make+up+tips.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Tyra+Banks+make+up+tips.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 18,
        contents: 10,
        name: {
            en: "E-Learning",
            be: "E-learning",
            id: "E-Learning",
            it: "E-Learning",
            se: "E-inlärning",
            ar: "التعلم الإلكتروني"
        },
        videos: [{
                duration: "Watch Now",
                id: 40,
                name: "Arabic Eps 1 - How to introduce yourself",
                preview: "https://cdn.mobiotv.com/bidiotv/E-Learning/Learn+Arabic+Eps+1+-+How+to+introduce+yourself.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/E-Learning/Learn+Arabic+Ep1+-+How+to+introduce+yourself.mp4",
                filename: "bidiotv/E-Learning/Learn+Arabic+Ep1+-+How+to+introduce+yourself.mp4"
            },
            {
                duration: "Watch Now",
                id: 41,
                name: "Arabic Eps 2 - Thank you",
                preview: "https://cdn.mobiotv.com/bidiotv/E-Learning/Learn+Arabic+Eps+2+-+Thank+you.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/E-Learning/Learn+Arabic+Ep2+-+Thank+you.mp4",
                filename: "bidiotv/E-Learning/Learn+Arabic+Ep2+-+Thank+you.mp4"
            },
            {
                duration: "Watch Now",
                id: 42,
                name: "English Eps 3 - Asking About Hobbies",
                preview: "https://cdn.mobiotv.com/bidiotv/E-Learning/English+Eps+3+-+Asking+About+Hobbies.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/E-Learning/Learn+English+Ep3+-+Asking+About+Hobbies.mp4",
                filename: "bidiotv/E-Learning/Learn+English+Ep3+-+Asking+About+Hobbies.mp4"
            },
            {
                duration: "Watch Now",
                id: 43,
                name: "English Eps 4 - Where are you from",
                preview: "https://cdn.mobiotv.com/bidiotv/E-Learning/English+Eps+4+-+Where+are+you+from.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/E-Learning/Learn+English+Ep4+-+Where+are+you+from.mp4",
                filename: "bidiotv/E-Learning/Learn+English+Ep4+-+Where+are+you+from.mp4"
            },
            {
                duration: "Watch Now",
                id: 44,
                name: "French Eps 5 - How to Apologize",
                preview: "https://cdn.mobiotv.com/bidiotv/E-Learning/French+Eps+5+-+How+to+Apologize.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/E-Learning/Learn+French+Ep5+-+How+to+Apologize.mp4",
                filename: "bidiotv/E-Learning/Learn+French+Ep5+-+How+to+Apologize.mp4"
            },
            {
                duration: "Watch Now",
                id: 45,
                name: "French Eps 6 - Asking do you Speak English",
                preview: "https://cdn.mobiotv.com/bidiotv/E-Learning/French+Eps+6+-+Asking+do+you+Speak+English.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/E-Learning/Learn+French+Ep6+-+Asking+do+you+Speak+English.mp4",
                filename: "bidiotv/E-Learning/Learn+French+Ep6+-+Asking+do+you+Speak+English.mp4"
            },
            {
                duration: "Watch Now",
                id: 46,
                name: "Italian Eps 7- Apologies",
                preview: "https://cdn.mobiotv.com/bidiotv/E-Learning/Italian+Eps+7-+Apologies.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/E-Learning/Learn+Italian+Ep7-+Apologies.mp4",
                filename: "bidiotv/E-Learning/Learn+Italian+Ep7-+Apologies.mp4"
            },
            {
                duration: "Watch Now",
                id: 47,
                name: "Italian Eps 8 - How much",
                preview: "https://cdn.mobiotv.com/bidiotv/E-Learning/Italian+Eps+8+-+How+much.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/E-Learning/Learn+Italian+Ep8-how+much.mp4",
                filename: "bidiotv/E-Learning/Learn+Italian+Ep8-how+much.mp4"
            },
            {
                duration: "Watch Now",
                id: 48,
                name: "Spanish Eps 9 - Where are you from",
                preview: "https://cdn.mobiotv.com/bidiotv/E-Learning/Spanish+Eps+9+-+Where+are+you+from.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/E-Learning/Learn+Spanish+Ep9+-+Where+are+you+from.mp4",
                filename: "bidiotv/E-Learning/Learn+Spanish+Ep9+-+Where+are+you+from.mp4"
            },
            {
                duration: "Watch Now",
                id: 49,
                name: "Spanish Eps 10 - What's up",
                preview: "https://cdn.mobiotv.com/bidiotv/E-Learning/Spanish+Eps+10+-+What's+up.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/E-Learning/Learn+Spanish+Ep10+-+What's+up.mp4",
                filename: "bidiotv/E-Learning/Learn+Spanish+Ep10+-+What's+up.mp4"
            }
        ]
    },
    {
        id: 19,
        contents: 11,
        name: {
            en: "Yoga",
            be: "Yoga",
            id: "Yoga",
            it: "Yoga",
            se: "Yoga",
            ar: "اليوغا"
        },
        videos: [{
                duration: "Watch Now",
                id: 50,
                name: "How to Post Natal Yoga Breathing Exercise",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+Post+Natal+Yoga++Breathing+Exercise.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Yoga/How+to+Post+Natal+Yoga++Breathing+Exercise.mp4",
                filename: "bidiotv/Yoga/How+to+Post+Natal+Yoga++Breathing+Exercise.mp4"
            },
            {
                duration: "Watch Now",
                id: 51,
                name: "How to Post Natal Yoga Breathing Exercise",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+Post+Natal+Yoga++Chair+Exercises.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Yoga/How+to+Post+Natal+Yoga++Chair+Exercises.mp4",
                filename: "bidiotv/Yoga/How+to+Post+Natal+Yoga++Chair+Exercises.mp4"
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 52,
            //     "name": "How to Post Natal Yoga Twist Walk",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+Post+Natal+Yoga++Twist+Walk.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.bidiotv.com/Yoga/How+to+Post+Natal+Yoga++Twist+Walk.mp4",
            //     "filename":"bidiotv/Yoga/How to Post Natal Yoga  Twist Walk.mp4",
            // },
            {
                duration: "Watch Now",
                id: 53,
                name: "How to in 60 seconds",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+in+60+seconds.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Yoga/How+to+in+60+seconds.mp4",
                filename: "bidiotv/Yoga/How+to+Post+Natal+Yoga++Twist+Walk.mp4"
            },
            {
                duration: "Watch Now",
                id: 54,
                name: "How to post natal yoga - Dandasana",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+post+natal+yoga+-+Dandasana.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Yoga/How+to+post+natal+yoga+-+Dandasana.mp4",
                filename: "bidiotv/Yoga/How+to+post+natal+yoga+-+Dandasana.mp4"
            },
            {
                duration: "Watch Now",
                id: 55,
                name: "How to post natal yoga - If baby needs entertainment",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+post+natal+yoga+-+If+baby+needs+entertainment.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Yoga/How+to+post+natal+yoga+-+If+baby+needs+entertainment.mp4",
                filename: "bidiotv/Yoga/How+to+post+natal+yoga+-+If+baby+needs+entertainment.mp4"
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 56,
            //     "name": "Pilates  Breast stroke",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Pilates++Breast+stroke.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.bidiotv.com/Yoga/Pilates++Breast+stroke.mp4",
            //     "filename":"bidiotv/Yoga/Pilates++Breast+stroke.mp4",
            // },
            {
                duration: "Watch Now",
                id: 57,
                name: "Pilates  Half roll back",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Pilates++Half+roll+back.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Yoga/Pilates++Half+roll+back.mp4",
                filename: "bidiotv/Yoga/Pilates++Half+roll+back.mp4"
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 58,
            //     "name": "Pilates  Hip roll",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Pilates++Hip+roll.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.bidiotv.com/Yoga/Pilates++Hip+roll.mp4",
            //     "filename":"bidiotv/Yoga/Pilates++Hip+roll.mp4",
            // },
            // {
            //     "duration": "Watch Now",
            //     "id": 59,
            //     "name": "Pilates  Intro push-up",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Pilates++Intro+push-up.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.bidiotv.com/Yoga/Pilates++Intro+push-up.mp4",
            //     "filename":"bidiotv/Yoga/Pilates++Intro+push-up.mp4",
            // },
            // {
            //     "duration": "Watch Now",
            //     "id": 107,
            //     "name": "1 Minute yoga Guide",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/1+Minute+yoga+Guide.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/1+Minute+yoga+Guide.mp4",
            //     "filename":"",
            // },
            //{
            //"duration": "Watch Now",
            //"id": 108,
            //"name": "1 Minute yoga guides",
            //"preview": "https://cdn.mobiotv.com/bidiotv/Yoga/1+Minute+yoga+guides.jpg",
            //"desc": "",
            //"videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/1+Minute+yoga+guides.mp4",
            //"filename":"",
            // },
            {
                duration: "Watch Now",
                id: 109,
                name: "Become flexible with yoga",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Become+flexible+with+yoga.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Yoga/Become+flexible+with+yoga.mp4",
                filename: ""
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 110,
            //     "name": "Blend with Yoga",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Blend+with+Yoga.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Blend+with+Yoga.mp4",
            //     "filename":"",
            // },
            // {
            //     "duration": "Watch Now",
            //     "id": 111,
            //     "name": "Fast and effective fatloss yoga",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Fast+and+effective+fatloss+yoga.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Fast+and+effective+fatloss+yoga.mp4",
            //     "filename":"",
            // },
            {
                duration: "Watch Now",
                id: 112,
                name: "Find peace at home with yoga",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Find+peace+at+home+with+yoga.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Yoga/Find+peace+at+home+with+yoga.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 113,
                name: "Find peace with yoga",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Find+peace+with+yoga.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Yoga/Find+peace+with+yoga.mp4",
                filename: ""
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 114,
            //     "name": "Free your body & mind",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Free+your+body+%26+mind.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Free+your+body+%26+mind.mp4",
            //     "filename":"",
            // },
            // {
            //     "duration": "Watch Now",
            //     "id": 115,
            //     "name": "Get abs with yoga",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Get+abs+with+yoga.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Get+abs+with+yoga.mp4",
            //     "filename":"",
            // },
            {
                duration: "Watch Now",
                id: 116,
                name: "Get slim & fit with yoga",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Get+slim+%26+fit+with+yoga.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Yoga/Get+slim+%26+fit+with+yoga.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 117,
                name: "Learn the art of yoga",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Learn+the+art+of+yoga.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Yoga/Learn+the+art+of+yoga.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 118,
                name: "Lost weight with yoga",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Lost+weight+with+yoga.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Yoga/Lost+weight+with+yoga.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 119,
                name: "Master core yoga poses",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Master+core+yoga+poses.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Yoga/Master+core+yoga+poses.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 120,
                name: "Mind over matter",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Mind+over+matter.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Yoga/Mind+over+matter.mp4",
                filename: ""
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 121,
            //     "name": "Stretch beyond with yoga",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Stretch+beyond+with+yoga.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Stretch+beyond+with+yoga.mp4",
            //     "filename":"",
            // },
            {
                duration: "Watch Now",
                id: 122,
                name: "Ultimate yoga guide",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Ultimate+yoga+guide.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Yoga/Ultimate+yoga+guide.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 123,
                name: "Yoga village",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Yoga+village.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Yoga/Yoga+village.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 124,
                name: "Yoga your way to healthy living",
                preview: "https://cdn.mobiotv.com/bidiotv/Yoga/Yoga+your+way+to+healthy+living.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Yoga/Yoga+your+way+to+healthy+living.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 20,
        contents: 24,
        name: {
            en: "Just For Laugh",
            be: "Gewoon om te lachen",
            id: "Just for Laugh",
            it: "Facciamoci una risata",
            se: "Bara på skoj",
            ar: "فقط للضحك"
        },
        videos: [{
                duration: "Watch Now",
                id: 70,
                name: "Animals Exoticos",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Animals+Exoticos.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Animals+Exoticos.mp4",
                filename: "bidiotv/Just+For+Laugh/Animals+Exoticos.mp4"
            },
            {
                duration: "Watch Now",
                id: 71,
                name: "Automatu",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Automatu.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Automatu.mp4",
                filename: "bidiotv/Just+For+Laugh/Automatu.mp4"
            },
            {
                duration: "Watch Now",
                id: 72,
                name: "Babies and Moving Table Part 1",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Babies_and_Moving_Table_Part+1.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Babies_and_Moving_Table_Part+1.mp4",
                filename: "bidiotv/Just+For+Laugh/Babies_and_Moving_Table_Part+1.mp4"
            },
            {
                duration: "Watch Now",
                id: 73,
                name: "Bad Kids Throw Orange Peels Part 1",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Bad_KidsThrow_Orange_Peels_Part+1.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Bad_KidsThrow_Orange_Peels_Part+1.mp4",
                filename: "bidiotv/Just+For+Laugh/Bad_KidsThrow_Orange_Peels_Part+1.mp4"
            },
            {
                duration: "Watch Now",
                id: 74,
                name: "Big Bunny Scares Babies Part 1",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Big+Bunny+Scares+Babies+Part1.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Big+Bunny+Scares+Babies+Part1.mp4",
                filename: "bidiotv/Just+For+Laugh/Big+Bunny+Scares+Babies+Part1.mp4"
            },
            {
                duration: "Watch Now",
                id: 76,
                name: "Bodyguards",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Bodyguards.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Bodyguards.mp4",
                filename: "bidiotv/Just+For+Laugh/Bodyguards.mp4"
            },
            {
                duration: "Watch Now",
                id: 77,
                name: "Cake on Face",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Cake+on+Face.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Cake+on+Face.mp4",
                filename: "bidiotv/Just+For+Laugh/Cake+on+Face.mp4"
            },
            {
                duration: "Watch Now",
                id: 78,
                name: "Can I Click your photo",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Can+I+Click+your+photo.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Can+I+Click+your+photo.mp4",
                filename: "bidiotv/Just+For+Laugh/Can+I+Click+your+photo.mp4"
            },
            {
                duration: "Watch Now",
                id: 79,
                name: "Car Parking",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Car+Parking.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Car+Parking.mp4",
                filename: "bidiotv/Just+For+Laugh/Car+Parking.mp4"
            },
            {
                duration: "Watch Now",
                id: 80,
                name: "Car for Sale",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Car+for+Sale.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Car+for+Sale.mp4",
                filename: "bidiotv/Just+For+Laugh/Car+for+Sale.mp4"
            },
            {
                duration: "Watch Now",
                id: 81,
                name: "Man Falling on Ladder",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Man+Falling+on+Ladder.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Man+Falling+on+Ladder.mp4",
                filename: "bidiotv/Just+For+Laugh/Man+Falling+on+Ladder.mp4"
            },
            {
                duration: "Watch Now",
                id: 82,
                name: "Man in Garbage Can Part 1",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Man+in+Garbage+Can+Part1.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Man+in+Garbage+Can+Part1.mp4",
                filename: "bidiotv/Just+For+Laugh/Man+in+Garbage+Can+Part1.mp4"
            },
            {
                duration: "Watch Now",
                id: 83,
                name: "Painting Exhibition",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/PAinting+Exhibition.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/PAinting+Exhibition.mp4",
                filename: "bidiotv/Just+For+Laugh/PAinting+Exhibition.mp4"
            },
            {
                duration: "Watch Now",
                id: 85,
                name: "Reckless Blind Man Part 1",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Reckless+Blind+Man+Part1.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Reckless+Blind+Man+Part1.mp4",
                filename: "bidiotv/Just+For+Laugh/Reckless+Blind+Man+Part1.mp4"
            },
            {
                duration: "Watch Now",
                id: 86,
                name: "Roller Blader Part 1",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Roller+Blader+Part1.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Roller+Blader+Part1.mp4",
                filename: "bidiotv/Just+For+Laugh/Roller+Blader+Part1.mp4"
            },
            {
                duration: "Watch Now",
                id: 87,
                name: "Rude Man on Beach Part 1",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Rude_Man_on_Beach_Part+1.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/Rude_Man_on_Beach_Part+1.mp4",
                filename: "bidiotv/Just+For+Laugh/Rude_Man_on_Beach_Part+1.mp4"
            },
            {
                duration: "Watch Now",
                id: 88,
                name: "Santa Claus The Pervert Part 1",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/SantaCluas_The_Pervert_Part+1.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/SantaCluas_The_Pervert_Part+1.mp4",
                filename: "bidiotv/Just+For+Laugh/SantaCluas_The_Pervert_Part+1.mp4"
            },
            {
                duration: "Watch Now",
                id: 89,
                name: "Baby Carier on Car",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/baby+carier+on+car.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/baby+carier+on+car.mp4",
                filename: "bidiotv/Just+For+Laugh/baby+carier+on+car.mp4"
            },
            {
                duration: "Watch Now",
                id: 90,
                name: "Bleeding Nose",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/bleeding+nose.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/bleeding+nose.mp4",
                filename: "bidiotv/Just+For+Laugh/bleeding+nose.mp4"
            },
            {
                duration: "Watch Now",
                id: 91,
                name: "Money Falling",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/money+falling.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/money+falling.mp4",
                filename: "bidiotv/Just+For+Laugh/money+falling.mp4"
            },
            {
                duration: "Watch Now",
                id: 92,
                name: "Open This Pen",
                preview: "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/open+this+pen.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Just+For+Laugh/open+this+pen.mp4",
                filename: "bidiotv/Just+For+Laugh/open+this+pen.mp4"
            }
        ]
    },
    {
        id: 21,
        contents: 24,
        name: {
            en: "Brain Boost",
            be: "Hersenversterking",
            id: "Brain Boost",
            it: "Stimola la mente",
            se: "Hjärnträning",
            ar: "تعزيز الدماغ"
        },
        videos: [{
                duration: "Watch Now",
                id: 93,
                name: "Ditch the doctor! How about diagnosis by computer",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Ditch+the+doctor!+How+about+diagnosis+by+computer.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/Ditch+the+doctor!+How+about+diagnosis+by+computer.mp4",
                filename: "bidiotv/Brain+Boost/Ditch+the+doctor!+How+about+diagnosis+by+computer.mp4"
            },
            {
                duration: "Watch Now",
                id: 94,
                name: "ESPN's new deal dives into the world of drone racing",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.mp4",
                filename: "bidiotv/Brain+Boost/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.mp4"
            },
            {
                duration: "Watch Now",
                id: 95,
                name: "Ever wished beer could fly Now it can!",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Ever+wished+beer+could+fly+Now+it+can!.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/Ever+wished+beer+could+fly+Now+it+can!.mp4",
                filename: "bidiotv/Brain+Boost/Ever+wished+beer+could+fly+Now+it+can!.mp4"
            },
            {
                duration: "Watch Now",
                id: 96,
                name: "Hearing things Here are 5 facts on our inner voice",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Hearing+things+Here+are+5+facts+on+our+inner+voice.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/Hearing+things+Here+are+5+facts+on+our+inner+voice.mp4",
                filename: "bidiotv/Brain+Boost/Hearing+things+Here+are+5+facts+on+our+inner+voice.mp4"
            },
            {
                duration: "Watch Now",
                id: 97,
                name: "Is spotty skin the answer to looking younger",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Is+spotty+skin+the+answer+to+looking+younger.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/Is+spotty+skin+the+answer+to+looking+younger.mp4",
                filename: "bidiotv/Brain+Boost/Is+spotty+skin+the+answer+to+looking+younger.mp4"
            },
            {
                duration: "Watch Now",
                id: 98,
                name: "Just why are the Dutch so tall",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Just+why+are+the+Dutch+so+tall.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/Just+why+are+the+Dutch+so+tall.mp4",
                filename: "bidiotv/Brain+Boost/Just+why+are+the+Dutch+so+tall.mp4"
            },
            {
                duration: "Watch Now",
                id: 99,
                name: "Meet the robot that wants to get to know you",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Meet+the+robot+that+wants+to+get+to+know+you.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/Meet+the+robot+that+wants+to+get+to+know+you.mp4",
                filename: "bidiotv/Brain+Boost/Meet+the+robot+that+wants+to+get+to+know+you.mp4"
            },
            {
                duration: "Watch Now",
                id: 100,
                name: "Star Wars becomes reality in a post-apocalyptic mall",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Star+Wars+becomes+reality+in+a+post+apocalyptic+mall.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/Star+Wars+becomes+reality+in+a+post-apocalyptic+mall.mp4",
                filename: "bidiotv/Brain+Boost/Star+Wars+becomes+reality+in+a+post-apocalyptic+mall.mp4"
            },
            {
                duration: "Watch Now",
                id: 101,
                name: "Sugar tax The answer to obesity pandemic",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Sugar+tax++The+answer+to+obesity+pandemic.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/Sugar+tax++The+answer+to+obesity+pandemic.mp4",
                filename: "bidiotv/Brain+Boost/Sugar+tax++The+answer+to+obesity+pandemic.mp4"
            },
            {
                duration: "Watch Now",
                id: 102,
                name: "Swallow this nano chip to know what s making you sick",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Swallow+this+nano+chip+to+know+what+s+making+you+sick.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/Swallow+this+nano+chip+to+know+what+s+making+you+sick.mp4",
                filename: "bidiotv/Brain+Boost/Swallow+this+nano+chip+to+know+what+s+making+you+sick.mp4"
            },
            {
                duration: "Watch Now",
                id: 103,
                name: "The exploding cost of cyberattacks",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/The+exploding+cost+of+cyberattacks.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/The+exploding+cost+of+cyberattacks.mp4",
                filename: "bidiotv/Brain+Boost/The+exploding+cost+of+cyberattacks.mp4"
            },
            {
                duration: "Watch Now",
                id: 104,
                name: "Turns out emails didn't solve our waste paper problems",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Turns+out+emails+didn+t+solve+our+waste+paper+problems.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Turns+out+emails+didn+t+solve+our+waste+paper+problems.mp4",
                filename: "bidiotv/Brain+Boost/Turns+out+emails+didn+t+solve+our+waste+paper+problems.mp4"
            },
            {
                duration: "Watch Now",
                id: 105,
                name: "UK Drone Show The latest consumer industry trends",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/UK+Drone+Show++The+latest+consumer+industry+trends.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/UK+Drone+Show++The+latest+consumer+industry+trends.mp4",
                filename: "bidiotv/Brain+Boost/UK+Drone+Show++The+latest+consumer+industry+trends.mp4"
            },
            {
                duration: "Watch Now",
                id: 106,
                name: "VR Running of the Bulls! A fearful thrillseekers dream",
                preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/VR+Running+of+the+Bulls!+A+fearful+thrillseekers+dream.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Brain+Boost/VR+Running+of+the+Bulls!+A+fearful+thrillseekers+dream.mp4",
                filename: "bidiotv/Brain+Boost/VR+Running+of+the+Bulls!+A+fearful+thrillseekers+dream.mp4"
            }
        ]
    },
    {
        id: 22,
        contents: 25,
        name: {
            en: "Rugby",
            be: "Rugby",
            id: "Rugby",
            it: "Rugby",
            se: "Rugby",
            ar: "كرة القدم الامريكية"
        },
        videos: [{
                duration: "Watch Now",
                id: 125,
                name: "Best Rugby Skills - Steps, Tricks, Offloads Compilation",
                preview: "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Skills+-+Steps%2C+Tricks%2C+Offloads+Compilation.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Skills+-+Steps%2C+Tricks%2C+Offloads+Compilation.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 126,
                name: "Best Rugby Skills 2018",
                preview: "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Skills+2018.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Skills+2018.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 127,
                name: "Best Rugby Tries 2018",
                preview: "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Tries+2018.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Tries+2018.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 128,
                name: "Craziest Rugby Skills",
                preview: "https://cdn.mobiotv.com/bidiotv/Rugby/Craziest+Rugby+Skills.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Rugby/Craziest+Rugby+Skills.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 129,
                name: "Epic Rugby Skills 2017",
                preview: "https://cdn.mobiotv.com/bidiotv/Rugby/Epic+Rugby+Skills+2017.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Rugby/Epic+Rugby+Skills+2017.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 130,
                name: "Epic Rugby Steps 2018",
                preview: "https://cdn.mobiotv.com/bidiotv/Rugby/Epic+Rugby+Steps+2018.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Rugby/Epic+Rugby+Steps+2018.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 131,
                name: "Rugby Big Hits 2018",
                preview: "https://cdn.mobiotv.com/bidiotv/Rugby/Rugby+Big+Hits+2018.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Rugby/Rugby+Big+Hits+2018.mp4",
                filename: ""
            }
        ]
    },
    // {
    //     "id":23,
    //     "contents":25,
    //     "name": {
    //         "en": "Astrology",
    //         "be": "Astrologie",
    //         "id": "Astrologi",
    //         "it": "Astrologia",
    //         "se": "Astrologi",
    //     },
    //     "videos":[
    //         {
    //             "duration": "Watch Now",
    //             "id": 132,
    //             "name": "Powerful zodiak 2019",
    //             "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Powerful+zodiac+2019.jpg",
    //             "desc": "",
    //             "videoUrl": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Powerful+zodiac+2019.mp4",
    //             "filename":""
    //         },
    //         {
    //             "duration": "Watch Now",
    //             "id": 133,
    //             "name": "Channeled message from your spirit guides",
    //             "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/Channeled+message+from+your+spirit+guides.jpg",
    //             "desc": "",
    //             "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/Channeled+message+from+your+spirit+guides.mp4",
    //             "filename":""
    //         },
    //         {
    //             "duration": "Watch Now",
    //             "id": 134,
    //             "name": "HOW & WHEN You Will You Become SUCCESSFUL",
    //             "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/HOW+%26+WHEN+You+Will+You+Become+SUCCESSFUL.jpg",
    //             "desc": "",
    //             "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/HOW+%26+WHEN+You+Will+You+Become+SUCCESSFUL.mp4",
    //             "filename":""
    //         },
    //         {
    //             "duration": "Watch Now",
    //             "id": 135,
    //             "name": "How do people you date-dated see you",
    //             "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/How+do+people+you+date-dated+see+you.jpg",
    //             "desc": "",
    //             "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/How+do+people+you+date-dated+see+you.mp4",
    //             "filename":""
    //         },
    //         {
    //             "duration": "Watch Now",
    //             "id": 136,
    //             "name": "Pick a card - Are they secretly thinking about you",
    //             "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+A+Card+-+What+Do+They+Secretly+Want+to+Tell+You.jpg",
    //             "desc": "",
    //             "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+A+Card+-+What+Do+They+Secretly+Want+to+Tell+You.mp4",
    //             "filename":""
    //         },
    //         {
    //             "duration": "Watch Now",
    //             "id": 137,
    //             "name": "Pick A Card - What Do They Secretly Want to Tell You",
    //             "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+a+card+-+Are+they+secretly+thinking+about+you.jpg",
    //             "desc": "",
    //             "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+a+card+-+Are+they+secretly+thinking+about+you.mp4",
    //             "filename":""
    //         },
    //         {
    //             "duration": "Watch Now",
    //             "id": 138,
    //             "name": "What’s Coming for You in 2019",
    //             "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/What%E2%80%99s+Coming+for+You+in+2019.jpg",
    //             "desc": "",
    //             "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/What%E2%80%99s+Coming+for+You+in+2019.mp4",
    //             "filename":""
    //         },
    //         {
    //             "duration": "Watch Now",
    //             "id": 139,
    //             "name": "Why do they act like this What's going on with them",
    //             "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/Why+do+they+act+like+this+What's+going+on+with+them.jpg",
    //             "desc": "",
    //             "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/Why+do+they+act+like+this+What's+going+on+with+them.mp4",
    //             "filename":""
    //         }
    //     ]

    // },
    {
        id: 24,
        contents: 25,
        name: {
            en: "Economy",
            be: "Economie",
            id: "Economy",
            it: "Economia",
            se: "Ekonomi",
            ar: "الاقتصاد"
        },
        videos: [{
                duration: "Watch Now",
                id: 728,
                name: "4 lessons to learn from business mogul Arianna Huffington",
                preview: "https://cdn.mobiotv.com/bidiotv/Economy/4+lessons+to+learn+from+business+mogul+Arianna+Huffington.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Economy/4+lessons+to+learn+from+business+mogul+Arianna+Huffington.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 729,
                name: "Builders of Tomorrow A Future Paved with Plastic",
                preview: "https://cdn.mobiotv.com/bidiotv/Economy/Builders+of+Tomorrow+A+Future+Paved+with+Plastic.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Economy/Builders+of+Tomorrow+A+Future+Paved+with+Plastic.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 730,
                name: "Just how vulnerable are jobs to robot takeovers",
                preview: "https://cdn.mobiotv.com/bidiotv/Economy/Just+how+vulnerable+are+jobs+to+robot+takeovers.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Economy/Just+how+vulnerable+are+jobs+to+robot+takeovers.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 26,
        contents: 25,
        name: {
            en: "Environment",
            be: "Milieu",
            id: "Environment",
            it: "Ambiente",
            se: "Miljö",
            ar: "الأخبار الترفيهية"
        },
        videos: [{
                duration: "Watch Now",
                id: 745,
                name: "Builders of Tomorrow Solar water heater from plastic bottles",
                preview: "https://cdn.mobiotv.com/bidiotv/Environment/Builders+of+Tomorrow+Solar+water+heater+from+plastic+bottles.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Environment/Builders+of+Tomorrow+Solar+water+heater+from+plastic+bottles.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 746,
                name: "Got plastic Here are four innovative ways to deal with it!",
                preview: "https://cdn.mobiotv.com/bidiotv/Environment/Got+plastic+Here+are+four+innovative+ways+to+deal+with+it!.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Environment/Got+plastic+Here+are+four+innovative+ways+to+deal+with+it!.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 748,
                name: "Saving the Planet and Making Art, One Butt at a Time",
                preview: "https://cdn.mobiotv.com/bidiotv/Environment/Saving+the+Planet+and+Making+Art%2C+One+Butt+at+a+Time.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Environment/Saving+the+Planet+and+Making+Art%2C+One+Butt+at+a+Time.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 749,
                name: "The fastest way to save the planet",
                preview: "https://cdn.mobiotv.com/bidiotv/Environment/The+fastest+way+to+save+the+planet.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Environment/The+fastest+way+to+save+the+planet.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 750,
                name: "The Unique Artist Turning Tires In Masterpieces",
                preview: "https://cdn.mobiotv.com/bidiotv/Environment/The+Unique+Artist+Turning+Tires+In+Masterpieces.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Environment/The+Unique+Artist+Turning+Tires+In+Masterpieces.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 27,
        contents: 25,
        name: {
            en: "Gaming",
            be: "Gaming",
            id: "Gaming",
            it: "Gaming",
            se: "Spel",
            ar: "الألعاب"
        },
        videos: [{
                duration: "Watch Now",
                id: 751,
                name: "5 Games You Will Lose Friends Over",
                preview: "https://cdn.mobiotv.com/bidiotv/Gaming/5+Games+You+Will+Lose+Friends+Over.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Gaming/5+Games+You+Will+Lose+Friends+Over.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 752,
                name: "5 Reasons to play Monster Hunter World",
                preview: "https://cdn.mobiotv.com/bidiotv/Gaming/5+Reasons+to+play+Monster+Hunter+World.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Gaming/5+Reasons+to+play+Monster+Hunter+World.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 754,
                name: "Best VR Experiences The survival test",
                preview: "https://cdn.mobiotv.com/bidiotv/Gaming/Best+VR+Experiences+The+survival+test.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Gaming/Best+VR+Experiences+The+survival+test.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 755,
                name: "Place your bets! GTA is getting a real virtual casino",
                preview: "https://cdn.mobiotv.com/bidiotv/Gaming/Place+your+bets!+GTA+is+getting+a+real+virtual+casino.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Gaming/Place+your+bets!+GTA+is+getting+a+real+virtual+casino.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 756,
                name: "Top 5 Gaming Lawsuits",
                preview: "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Gaming+Lawsuits.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Gaming+Lawsuits.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 757,
                name: "Top 5 Highest Grossing Arcade Games",
                preview: "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Highest+Grossing+Arcade+Games.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Highest+Grossing+Arcade+Games.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 758,
                name: "Top 5 Legendary Game Couples",
                preview: "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Legendary+Game+Couples.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Legendary+Game+Couples.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 28,
        contents: 25,
        name: {
            en: "Lifestyle",
            be: "Lifestyle",
            id: "Lifestyle",
            it: "Stile di vita",
            se: "Livsstil",
            ar: "نمط الحياة"
        },
        videos: [{
                duration: "Watch Now",
                id: 760,
                name: "Crazy Cravings 'I've been eating chalk for over twenty years",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Crazy+Cravings+'I've+been+eating+chalk+for+over+twenty+years'.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Crazy+Cravings+'I've+been+eating+chalk+for+over+twenty+years'.mp4",
                filename: ""
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 761,
            //     "name": "Crazy Cravings 'Sex toys allows me to feel confident",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Crazy+Cravings+'Sex+toys+allows+me+to+feel+confident'.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Crazy+Cravings+'Sex+toys+allows+me+to+feel+confident'.mp4",
            //     "filename":"",
            // },
            {
                duration: "Watch Now",
                id: 762,
                name: "Dargavs Welcome to the City of the Dead",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Dargavs+Welcome+to+the+City+of+the+Dead.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Dargavs+Welcome+to+the+City+of+the+Dead.mp4",
                filename: ""
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 763,
            //     "name": "Dream Job  My Life As A Travel Blogger",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Dream+Job++My+Life+As+A+Travel+Blogger.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Dream+Job++My+Life+As+A+Travel+Blogger.mp4",
            //     "filename":"",
            // },
            {
                duration: "Watch Now",
                id: 764,
                name: "Heroes Neighborhood Tour Frida Kahlo ",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Heroes+Neighborhood+Tour+Frida+Kahlo.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Heroes+Neighborhood+Tour+Frida+Kahlo.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 766,
                name: "Solo Trip Hidden Gems of Bali",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+Hidden+Gems+of+Bali.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+Hidden+Gems+of+Bali.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 767,
                name: "Solo Trip Hidden Gems of Bogor (Indonesia)",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+Hidden+Gems+of+Bogor+(Indonesia).jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+Hidden+Gems+of+Bogor+(Indonesia).mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 768,
                name: "Solo Trip The Hidden Gems Of Rotterdam",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+The+Hidden+Gems+Of+Rotterdam.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+The+Hidden+Gems+Of+Rotterdam.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 769,
                name: "Sugary drink lovers, this one's for you!",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Sugary+drink+lovers%2C+this+one's+for+you!.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/Sugary+drink+lovers%2C+this+one's+for+you!.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 770,
                name: "The 5 most iconic Armani red carpet looks of all time",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+5+most+iconic+Armani+red+carpet+looks+of+all+time.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+5+most+iconic+Armani+red+carpet+looks+of+all+time.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 771,
                name: "The Most Amazing Island Canary Islands",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Canary+Islands.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Canary+Islands.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 772,
                name: "The Most Amazing Island Favignana Sicily",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Favignana+Sicily.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Favignana+Sicily.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 773,
                name: "The Most Amazing Island Texel",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Texel.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Texel.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 774,
                name: "These nations give expats the best online life",
                preview: "https://cdn.mobiotv.com/bidiotv/Lifestyle/These+nations+give+expats+the+best+online+life.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Lifestyle/These+nations+give+expats+the+best+online+life.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 29,
        contents: 25,
        name: {
            en: "Local Heroes",
            be: "Lokale helden",
            id: "Local Heroes",
            it: "Eroi locali",
            se: "Lokala hjältar",
            ar: "ابطال محليون"
        },
        videos: [{
                duration: "Watch Now",
                id: 775,
                name: "There’s no power from keeping it to yourself'",
                preview: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/'There%E2%80%99s+no+power+from+keeping+it+to+yourself'.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/'There%E2%80%99s+no+power+from+keeping+it+to+yourself'.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 776,
                name: "3 Things Malala has said that will totally inspire you",
                preview: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/3+Things+Malala+has+said+that+will+totally+inspire+you.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/3+Things+Malala+has+said+that+will+totally+inspire+you.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 777,
                name: "Border Angels Saving lives with water",
                preview: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Border+Angels+Saving+lives+with+water.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Border+Angels+Saving+lives+with+water.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 778,
                name: "Bullied To Influencer 'Painting helps me dodge my problems",
                preview: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Bullied+To+Influencer+'Painting+helps+me+dodge+my+problems'.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Bullied+To+Influencer+'Painting+helps+me+dodge+my+problems'.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 779,
                name: "Bullied to Influencer 'You can be the light in the darkness",
                preview: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Bullied+to+Influencer+'You+can+be+the+light+in+the+darkness'.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Bullied+to+Influencer+'You+can+be+the+light+in+the+darkness'.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 780,
                name: "Peace Builders Fighting gangs with clowning",
                preview: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Peace+Builders+Fighting+gangs+with+clowning.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Peace+Builders+Fighting+gangs+with+clowning.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 781,
                name: "Peacebuilders Inside the Community Ring",
                preview: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Peacebuilders+Inside+the+Community+Ring.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Peacebuilders+Inside+the+Community+Ring.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 782,
                name: "Sport for Change A sure shot to female empowerment in Zimbabwe",
                preview: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Sport+for+Change+A+sure+shot+to+female+empowerment+in+Zimbabwe.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Sport+for+Change+A+sure+shot+to+female+empowerment+in+Zimbabwe.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 783,
                name: "Young CEO Mr. Cory’s Cookies",
                preview: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Young+CEO+Mr.+Cory%E2%80%99s+Cookies.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Young+CEO+Mr.+Cory%E2%80%99s+Cookies.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 30,
        contents: 25,
        name: {
            en: "Sports",
            be: "Sport nieuws",
            id: "Sports",
            it: "Notizie sportive",
            se: "Sporter",
            ar: "الأخبار الرياضية"
        },
        videos: [{
                duration: "Watch Now",
                id: 784,
                name: "Amazing Tennis Courts A Court Hidden Among Cliffs",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports+News/Amazing+Tennis+Courts+A+Court+Hidden+Among+Cliffs.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Sports+News/Amazing+Tennis+Courts+A+Court+Hidden+Among+Cliffs.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 785,
                name: "Best VR Experiences The extreme sports simulator",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports+News/Best+VR+Experiences+The+extreme+sports+simulator.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Sports+News/Best+VR+Experiences+The+extreme+sports+simulator.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 786,
                name: "Don’t expect the U.S. Women’s Football squad at the White House",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports+News/Don%E2%80%99t+expect+the+U.S.+Women%E2%80%99s+Football+squad+at+the+White+House.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Sports+News/Don%E2%80%99t+expect+the+U.S.+Women%E2%80%99s+Football+squad+at+the+White+House.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 787,
                name: "Future Female Footballer Colombia's Salomé is gonna be a pro",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports+News/Future+Female+Footballer+Colombia's+Salome%CC%81+is+gonna+be+a+pro.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Sports+News/Future+Female+Footballer+Colombia's+Salome%CC%81+is+gonna+be+a+pro.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 788,
                name: "My Underground Sport Alan Nasty Nash is a champ toe wrestler",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Sports+News/My+Underground+Sport+Alan+Nasty+Nash+is+a+champ+toe+wrestler.mp4",
                desc: "",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports+News/My+Underground+Sport+Alan+Nasty+Nash+is+a+champ+toe+wrestler.jpg",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 789,
                name: "My Underground Sport Kabaddi's growing in India",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports+News/My+Underground+Sport+Kabaddi's+growing+in+India.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Sports+News/My+Underground+Sport+Kabaddi's+growing+in+India.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 790,
                name: "Sport for Change A goal for inclusion",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports+News/Sport+for+Change+A+goal+for+inclusion.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Sports+News/Sport+for+Change+A+goal+for+inclusion.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 791,
                name: "Sport for Change The initiative hitting it out of the park",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports+News/Sport+for+Change+The+initiative+hitting+it+out+of+the+park.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Sports+News/Sport+for+Change+The+initiative+hitting+it+out+of+the+park.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 792,
                name: "The 5 best summer football transfers so far!",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports+News/The+5+best+summer+football+transfers+so+far!.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Sports+News/The+5+best+summer+football+transfers+so+far!.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 14,
                name: "Coaches Clinic Pete Herrman",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports/Coaches+Clinic++Pete+Herrman.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Sports/Coaches+Clinic++Pete+Herrman.mp4",
                filename: "bidiotv/Sports/Coaches+Clinic+Pete+Herrman.mp4"
            },
            {
                duration: "Watch Now",
                id: 15,
                name: "Dribble Drive Motion Skills",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports/Dribble+Drive+Motion+Skills.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Sports/Dribble+Drive+Motion+Skills.mp4",
                filename: "bidiotv/Sports/Dribble+Drive+Motion+Skills.mp4"
            },
            {
                duration: "Watch Now",
                id: 16,
                name: "GAMCA Coaches Clinic",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports/GAMCA+Coaches+Clinic.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Sports/GAMCA+Coaches+Clinic.mp4",
                filename: "bidiotv/Sports/GAMCA+Coaches+Clinic.mp4"
            },
            {
                duration: "Watch Now",
                id: 17,
                name: "Robert Tutein (UTICA) - 2016 GEICO Play of the Year Nominee",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports/ROBERT+TUTEIN+(UTICA)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Sports/ROBERT+TUTEIN+(UTICA)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                filename: "bidiotv/Sports/ROBERT+TUTEIN+(UTICA)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4"
            },
            {
                duration: "Watch Now",
                id: 18,
                name: "Ryan Kelley (ARCADIA) - 2016 GEICO Play of the Year Nominee",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports/RYAN+KELLEY+(ARCADIA)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Sports/RYAN+KELLEY+(ARCADIA)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                filename: "bidiotv/Sports/RYAN+KELLEY+(ARCADIA)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4"
            },
            {
                duration: "Watch Now",
                id: 19,
                name: "Sam Borst Smith (ROCHESTER) - 2016 GEICO Play of the Year Nominee",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports/SAM+BORST+SMITH+(ROCHESTER)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Sports/SAM+BORST+SMITH+(ROCHESTER)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                filename: "bidiotv/Sports/SAM+BORST+SMITH+(ROCHESTER)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4"
            },
            {
                duration: "Watch Now",
                id: 20,
                name: "Special Spectators visits the College Slam Dunk & 3- Point Championships Intersport",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports/Special+Spectators+visits+the+College+Slam+Dunk+%26+3-Point+Championships+Intersport.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Sports/Special+Spectators+visits+the+College+Slam+Dunk+%26+3-Point+Championships+Intersport.mp4",
                filename: "bidiotv/Sports/Special+Spectators+visits+the+College+Slam+Dunk+%26+3-Point+Championships+Intersport.mp4"
            },
            {
                duration: "Watch Now",
                id: 21,
                name: "Tanner Schieve (Wisconsin Lutheran College) - 2016 GEICO Play of the Year Nominee",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports/Tanner+Schieve+(Wisconsin+Lutheran+College)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Sports/Tanner+Schieve+(Wisconsin+Lutheran+College)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                filename: "bidiotv/Sports/Tanner+Schieve+(Wisconsin+Lutheran+College)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4"
            },
            {
                duration: "Watch Now",
                id: 22,
                name: "Trevor Krizenesky (Concordia University Wisconsin) - 2016 GEICO Play of the Year Nominee",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports/Trevor+Krizenesky+(Concordia+University+-+Wisconsin)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Sports/Trevor+Krizenesky+(Concordia+University+-+Wisconsin)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                filename: "bidiotv/Sports/Trevor+Krizenesky+(Concordia+University+-+Wisconsin)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4"
            },
            {
                duration: "Watch Now",
                id: 23,
                name: "Venky Jois (EASTERN WASHINGTON) - 2016 GEICO Play of the Year Nominee",
                preview: "https://cdn.mobiotv.com/bidiotv/Sports/VENKY+JOIS+(EASTERN+WASHINGTON)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                desc: "",
                videoUrl: "https://cdn.bidiotv.com/Sports/VENKY+JOIS+(EASTERN+WASHINGTON)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                filename: "bidiotv/Sports/VENKY+JOIS+(EASTERN+WASHINGTON)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4"
            },
            {
                duration: "Watch Now",
                id: 801,
                name: "Learn Freestyle Football Tricks Lemmens around the world",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/Learn+Freestyle+Football+Tricks+Lemmens+around+the+world.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/Learn+Freestyle+Football+Tricks+Lemmens+around+the+world.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 802,
                name: "Pro Footballer Training A Need For Speed",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+A+Need+For+Speed.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+A+Need+For+Speed.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 803,
                name: "Pro Footballer Training Leg-Focused Exercises",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+Leg-Focused+Exercises.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+Leg-Focused+Exercises.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 804,
                name: "Pro Footballer Training Muscles-Focused Exercises",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+Muscles-Focused+Exercises.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+Muscles-Focused+Exercises.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 31,
        contents: 25,
        name: {
            en: "Technology",
            be: "Technologie",
            id: "Technology",
            it: "Tecnologia",
            se: "Teknologi",
            ar: "تقنية"
        },
        videos: [{
                duration: "Watch Now",
                id: 793,
                name: "Best VR Experiences Into the shark tank",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/Best+VR+Experiences+Into+the+shark+tank.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/Best+VR+Experiences+Into+the+shark+tank.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 794,
                name: "From Human to Cyborg",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/From+Human+to+Cyborg.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/From+Human+to+Cyborg.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 795,
                name: "Futuristic Transport Getting around never looked so cool",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/Futuristic+Transport+Getting+around+never+looked+so+cool.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/Futuristic+Transport+Getting+around+never+looked+so+cool.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 796,
                name: "NASA’s next destination in 2026 Titan",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/NASA%E2%80%99s+next+destination+in+2026+Titan.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/NASA%E2%80%99s+next+destination+in+2026+Titan.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 797,
                name: "Visit a Space Place Korolev, Russia's deep space history",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+Korolev%2C+Russia's+deep+space+history.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+Korolev%2C+Russia's+deep+space+history.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 798,
                name: "Visit a Space Place The Meteor Crater",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Meteor+Crater.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Meteor+Crater.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 799,
                name: "Visit a Space Place The Netherlands' Space Simulator",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Netherlands'+Space+Simulator.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Netherlands'+Space+Simulator.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 32,
        contents: 25,
        name: {
            en: "Tutorials",
            be: "tutorials",
            id: "Tutorials",
            it: "Esercitazioni",
            se: "Tutorials",
            ar: "دروس"
        },
        videos: [{
                duration: "Watch Now",
                id: 800,
                name: "How To be green at home Natural Stain Remover",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/How+To+be+green+at+home+Natural+Stain+Remover.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/How+To+be+green+at+home+Natural+Stain+Remover.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 811,
                name: "Wanna be a DJ Start with the basics from a pro",
                preview: "https://cdn.mobiotv.com/bidiotv/Tutorials/Wanna+be+a+DJ+Start+with+the+basics+from+a+pro.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Tutorials/Wanna+be+a+DJ+Start+with+the+basics+from+a+pro.mp4",
                filename: ""
            }
        ]
    },
    {
        id: 31,
        contents: 25,
        name: {
            en: "Technology",
            be: "Technologie",
            id: "Technology",
            it: "Tecnologia",
            se: "Teknologi",
            ar: "تقنية"
        },
        videos: [{
                duration: "Watch Now",
                id: 793,
                name: "Best VR Experiences Into the shark tank",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/Best+VR+Experiences+Into+the+shark+tank.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/Best+VR+Experiences+Into+the+shark+tank.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 794,
                name: "From Human to Cyborg",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/From+Human+to+Cyborg.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/From+Human+to+Cyborg.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 795,
                name: "Futuristic Transport Getting around never looked so cool",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/Futuristic+Transport+Getting+around+never+looked+so+cool.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/Futuristic+Transport+Getting+around+never+looked+so+cool.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 796,
                name: "NASA’s next destination in 2026 Titan",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/NASA%E2%80%99s+next+destination+in+2026+Titan.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/NASA%E2%80%99s+next+destination+in+2026+Titan.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 797,
                name: "Visit a Space Place Korolev, Russia's deep space history",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+Korolev%2C+Russia's+deep+space+history.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+Korolev%2C+Russia's+deep+space+history.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 798,
                name: "Visit a Space Place The Meteor Crater",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Meteor+Crater.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Meteor+Crater.mp4",
                filename: ""
            },
            {
                duration: "Watch Now",
                id: 799,
                name: "Visit a Space Place The Netherlands' Space Simulator",
                preview: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Netherlands'+Space+Simulator.jpg",
                desc: "",
                videoUrl: "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Netherlands'+Space+Simulator.mp4",
                filename: ""
            }
        ]
    }
];


// WEBPACK FOOTER //
// ./src/constants/bidiotvmovies_iq.js